import React from 'react';
import ScrollAnimation from '../ScrollAnimation';
import Carousel from '../problems/Carousel';
import { problems } from '../problems/problemsData';

export default function IrreplacableProblems() {
  return (
    <ScrollAnimation>
      <section className="py-12 bg-white overflow-hidden">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-10 stagger-item">
            <h2 className="text-3xl font-bold text-gray-900 sm:text-4xl mb-4">
              Finding these career challenges familiar?
            </h2>
          </div>

          <Carousel items={problems} />

          <div className="text-center mt-12">
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              We understand, that's why we've designed our platform to address these exact pain points.
            </p>
          </div>
        </div>
      </section>
    </ScrollAnimation>
  );
}